export default __webpack_public_path__ + "static/media/tick.88b11c8b.svg";